import React, { useRef, useState } from 'react';
import { Voucher } from '../../models/voucher.model';
import { usePdfViewer } from '../../contexts/PdfViewerContext';

interface ButtonVouchersProps {
  vouchers?: Voucher[] | any[];
}

const ButtonVouchers: React.FC<ButtonVouchersProps> = ({ vouchers }) => {
  const { open } = usePdfViewer();
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const safeVouchers = vouchers ?? [];
  if (safeVouchers.length === 0) return null;

  const openVoucher = (v: Voucher) => {
    if (v.id_document_inbox) {
      open(v.id_document_inbox);
    } else if (v.file) {
      window.open(v.file, '_blank');
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (safeVouchers.length === 1) {
      openVoucher(safeVouchers[0]);
    } else {
      setShowDropdown(prev => !prev);
    }
  };

  const handleItemClick = (e: React.MouseEvent, v: Voucher) => {
    e.preventDefault();
    e.stopPropagation();
    openVoucher(v);
    setShowDropdown(false);
  };

  const handleBlur = (e: React.FocusEvent) => {
    if (containerRef.current && !containerRef.current.contains(e.relatedTarget as Node)) {
      setShowDropdown(false);
    }
  };

  return (
    <div ref={containerRef} className="position-relative d-inline-block" onBlur={handleBlur}>
      <button
        type="button"
        className="btn btn-icon btn-sm btn-light-primary"
        title={`${safeVouchers.length} document${safeVouchers.length > 1 ? 's' : ''}`}
        onClick={handleClick}
      >
        <i className="bi bi-paperclip fs-4"></i>
        {safeVouchers.length > 1 && (
          <span className="badge badge-circle badge-sm badge-primary position-absolute top-0 end-0 translate-middle">{safeVouchers.length}</span>
        )}
      </button>
      {showDropdown && safeVouchers.length > 1 && (
        <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-2 show position-absolute end-0 mt-1" style={{zIndex: 107}}>
          {safeVouchers.map((v: Voucher, i: number) => (
            <div key={i} className="menu-item px-3">
              <a
                href="#"
                className="menu-link px-3 text-truncate"
                onClick={(e) => handleItemClick(e, v)}
              >
                <i className="bi bi-file-earmark me-2 fs-6"></i>
                {v.original_name ?? v.name ?? `Document ${i + 1}`}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ButtonVouchers;
